// Google Maps helpers — extracted from legacy-utils.ts

export function getGoogleMapsPolygonBounds(polygon: google.maps.Polygon): google.maps.LatLngBounds {
  const bounds = new google.maps.LatLngBounds();
  const paths = polygon.getPaths();
  let path;
  for (var i = 0; i < paths.getLength(); i++) {
    path = paths.getAt(i);
    for (var ii = 0; ii < path.getLength(); ii++) {
      bounds.extend(path.getAt(ii));
    }
  }
  return bounds;
}
